module.exports = __webpack_public_path__ + "img/20250813SelmaFynn-14.da507757.jpg";